__turbopack_context__.v({
  "filters": "alphabet-filters-module-scss-module__YCKCNa__filters",
  "legend": "alphabet-filters-module-scss-module__YCKCNa__legend",
});
